<template>
    <basic-modal @hide="close"
                 v-model="opened"
                 aria-label="New Wiki"
                 role="dialog"
    >
        <div slot="header">
            <basic-modal-close-button ref="closeButton"></basic-modal-close-button>
            <h3 class="modal-title">Create access link</h3>
        </div>
        <div class="alert alert-warning">
            This access link will expire in the term specified here. You can edit or extend the expiry date in the
            '<strong>Manage Access</strong>' table after link is created.
            <br>
            Remember to specify what access you want to give to this link after you have created it by clicking
            '<strong>edit access</strong>' in the manage access table.
        </div>
        <div>
            <form action="#" @submit.stop.prevent="createLink">
                <div class="row">
                    <div class="col-sm-12">
                        <div>
                            <strong>Name: <span class="color-tag-gray">(required)</span></strong>
                            <input
                                    ref="name-input"
                                    v-model="name"
                                    maxlength="127"
                                    type="text"
                                    class="form-control"
                                    placeholder="Name of Access Link"
                                    required/>
                        </div>
                    </div>
                </div>
                <div class="row margin-15-top">
                    <div class="col-sm-12">
                        <div>
                            <strong>Link expires in:</strong>
                            <select class="form-control" v-model="validityTerm">
                                <option :value="term.val" v-for="term in accessLinkPossibleTerms" :key="term.val">{{
                                        term.name
                                    }}
                                </option>
                            </select>
                        </div>
                    </div>
                </div>
            </form>
        </div>
        <div slot="footer">
            <button class="btn btn-mm btn-green" @click="createLink" :disabled="!name">Create</button>
        </div>
    </basic-modal>
</template>

<script>
    import BasicModal from '../../../../../vue/common_components/BasicModal.vue';
    import BasicModalCloseButton from '../../../../../vue/common_components/BasicModalCloseButton.vue';
    import PopupPromiseMixin from '../../../../../vue/mixins/PopupPromiseMixin';

    export default {
        name: 'CreateAccessLinkPopup',
        mixins: [PopupPromiseMixin],
        components: {
            BasicModalCloseButton,
            BasicModal
        },
        data () {
            return {
                name: '',
                validityTerm: 14,
            };
        },
        computed: {
            firstFocusEl () {
                return this.$refs['name-input'];
            },
            accessLinkPossibleTerms () {
                return [
                    {
                        name: 'never',
                        val: null
                    },
                    {
                        name: '3 days',
                        val: 3
                    },
                    {
                        name: '1 week',
                        val: 7
                    },
                    {
                        name: '2 weeks',
                        val: 14
                    },
                    {
                        name: '1 month',
                        val: 30
                    },
                ];
            }
        },
        methods: {
            createLink () {
                if (!this.name) {
                    return;
                }
                this.save({
                    name: this.name,
                    term_days: this.validityTerm
                });
            }
        }
    };
</script>
